module.exports = __webpack_public_path__ + "img/7.c4d6af35.jpg";